(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3896],{

/***/ 9052:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ad-examples/[slug]",
      function () {
        return __webpack_require__(5432);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ AdExamplesPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6106);


var __N_SSP = true;
function AdExamplesPage(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(sections_gallery_all_gallery__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        galleryJobs: null,
        initialFiltersGallery: null,
        availableFiltersGallery: props.availableFiltersGallery,
        templatesJobs: null,
        initialFiltersTemplates: null,
        availableFiltersTemplates: props.availableFiltersTemplates,
        adExamplesJobs: props.jobs,
        initialFiltersAdExamples: props.initial,
        pageTitle: props.pageTitle,
        metaLinks: props.metaLinks,
        pageNumber: props.pageNumber,
        initialPage: "ad-examples"
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(9052); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);